import React from 'react';
import styles from './RoundNavigationPopup.module.css';
import { RoundData } from '../utils/types';

interface RoundNavigationPopupProps {
  currentRound: number;
  roundsData: RoundData[];
  onRoundChange: (round: number) => void;
  onClose: () => void;
  hasSubscription: boolean;
  matchId: string;
}

const RoundNavigationPopup: React.FC<RoundNavigationPopupProps> = ({
  currentRound,
  roundsData,
  onRoundChange,
  onClose,
  hasSubscription,
  matchId,
}) => {
  const handleRoundClick = (round: number) => {
    onRoundChange(round);
    onClose();
  };

  // Add function to check if match is 30 days or older
  const isMatchOlderThan30Days = (matchId: string): boolean => {
    const matchDate = new Date(matchId.substring(0, 10));
    const currentDate = new Date();
    const diffTime = Math.abs(currentDate.getTime() - matchDate.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays >= 30;
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <button className={styles.closeButton} onClick={onClose}>
          &times;
        </button>
        <h4>Select Round</h4>
        <div className={styles.roundGrid}>
          {roundsData.map((round) => {
            const isRestricted = round.round_number > 12 && !hasSubscription && !isMatchOlderThan30Days(matchId);
            return (
              <button
                key={round.round_number}
                className={`${styles.roundButton} ${
                  round.round_number === currentRound ? styles.active : ''
                } ${round.enabled ? '' : styles.disabled} ${isRestricted ? styles.restricted : ''}`}
                onClick={() => handleRoundClick(round.round_number)}
                disabled={!round.enabled}
                title={isRestricted ? "Round unavailable for this account" : undefined}
              >
                {isRestricted ? (
                  <i className="bi bi-lock-fill"></i>
                ) : (
                  round.round_number
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RoundNavigationPopup;